import { Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { PlanConfig } from "./types";

interface PlanHeaderCellProps {
  plan: PlanConfig;
  isCurrentPlan: boolean;
  isLast?: boolean;
  isDesktop?: boolean;
}

export const PlanHeaderCell = ({ plan, isCurrentPlan, isLast, isDesktop = false }: PlanHeaderCellProps) => {
  return (
    <th
      className={clsx(
        "px-2.5 py-2 text-center align-top font-normal",
        isDesktop ? "w-auto" : "w-[250px]",
        isCurrentPlan ? "bg-primary-tint-light" : "bg-neutral-surface-gray",
        isLast && "rounded-tr-lg"
      )}
    >
      <div className="flex w-full flex-col items-center gap-1">
        {isCurrentPlan && (
          <div className="-mt-6 mb-1 flex items-center justify-center whitespace-nowrap rounded-full border border-primary bg-primary-light px-2 py-0.5">
            <Typography variant="action" className="text-primary">
              Current Plan
            </Typography>
          </div>
        )}
        <div className="flex w-full min-w-0 max-w-full flex-row items-center gap-3">
          {plan.iconSvg && (
            <div className="h-6 w-6 flex-shrink-0 [&>svg]:h-full [&>svg]:w-full" dangerouslySetInnerHTML={{ __html: plan.iconSvg }} />
          )}
          <div className="min-w-0 flex-1 truncate">
            <Typography variant="h2" className="truncate">
              {plan.name}
            </Typography>
          </div>
        </div>
        <Typography variant="paragraph">Monthly Total: ${Math.round(plan.fee / 100)}</Typography>
      </div>
    </th>
  );
};
